export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/continuous_discovery_teams-8f35e65932b822628cc2213f2c009f7e.png";